<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            v-on="{ ...tooltip, ...dialog }"
            fab
            small
            dark
            class="mr-2"
            color="blue"
          >
            <v-icon> mdi-account-edit </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("users.edit.label", { email: user.email }) }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{
          $t("users.edit.label", { email: user.email })
        }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="userEditForm" v-model="valid" lazy-validation>
          <v-text-field v-model="user.forename" :label="$t('users.forename')">
          </v-text-field>
          <v-text-field v-model="user.surname" :label="$t('users.surname')">
          </v-text-field>
          <v-text-field
            v-model="user.password"
            :label="$t('users.password')"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
          >
          </v-text-field>
          <v-select
            v-model="user.role_value"
            :items="roles.list"
            :rules="rules.required"
            item-text="label"
            item-value="value"
            :label="$t('users.role')"
          >
          </v-select>
        </v-form>

        <v-form
          v-if="user.role.toLowerCase() === roles.PARTNER"
          ref="companyEditForm"
          v-model="companyValid"
          lazy-validation
        >
          <v-subheader>{{ $t("users.register.company.section") }}</v-subheader>
          <v-text-field
            :label="$t('company.name')"
            :rules="rules.required"
            v-model="editedCompany.name"
          >
          </v-text-field>
          <v-text-field :label="$t('company.nip')" v-model="editedCompany.nip">
          </v-text-field>
          <v-text-field
            :label="$t('company.address')"
            v-model="editedCompany.address"
          >
          </v-text-field>
          <v-text-field
            :label="$t('company.phone')"
            v-model="editedCompany.phone"
          >
          </v-text-field>
          <v-text-field
            :label="$t('company.account')"
            v-model="editedCompany.account"
          >
          </v-text-field>
          <v-text-field
            :label="$t('company.payment')"
            v-model="editedCompany.payment"
          >
          </v-text-field>
          <v-text-field
            :label="$t('company.contact')"
            v-model="editedCompany.contact"
          >
          </v-text-field>
          <v-select
            v-model="editedUser.traders"
            :items="traders"
            :menu-props="{ maxHeight: '400' }"
            :item-text="(item) => `${item.surname} ${item.forename}`"
            item-value="id"
            :label="$t('user.roles.trader')"
            multiple
            persistent-hint
          ></v-select>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-progress-circular v-if="editing" indeterminate></v-progress-circular>
        <v-btn
          :disabled="editing || !valid"
          color="blue darken-1"
          text
          @click="submit"
          >{{ $t("users.register.submit") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import roles from "@/helpers/users/roles";

export default {
  name: "Edit",
  props: ["rules", "user"],
  computed: {
    roles() {
      return roles;
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      companyValid: false,
      showPassword: false,
      editing: false,
      editedUser: {
        password: "",
        role_value: "",
      },
      editedCompany: this.user.company,
      traders: null,
    };
  },
  methods: {
    submit() {
      if (this.user.role.toLowerCase() === roles.PARTNER) {
        if (
          this.$refs.userEditForm.validate() &&
          this.$refs.companyEditForm.validate()
        ) {
          this.updateCompany();
        }
      } else if (this.$refs.userEditForm.validate()) {
        this.updateUser();
      }
    },
    updateCompany() {
      this.$http
        .put("company/" + this.editedCompany.id, {company: this.editedCompany})
        .then(() => {
          this.updateUser();
        })
        .catch((error) => {
          this.dialog = false;
          this.$emit("result", {
            message: this.$t("users.edit.fail"),
            color: "error",
          });
        });
    },
    updateUser() {
      this.$http
        .patch("users/" + this.user.id, {
          forename: this.user.forename,
          surname: this.user.surname,
          password: this.user.password,
          role: this.user.role_value,
          traders: this.editedUser.traders,
        })
        .then(() => {
          this.dialog = false;
          this.$emit("reload");
          this.$emit("result", {
            message: this.$t("users.edit.success"),
            color: "success",
          });
        })
        .catch(() => {
          this.dialog = false;
          this.$emit("result", {
            message: this.$t("users.edit.fail"),
            color: "error",
          });
        });
    },
  },
  mounted() {
    this.editedUser.forename = this.user.forename;
    this.editedUser.surname = this.user.surname;
    this.editedUser.traders = this.user.traders;
    this.editedUser.role_value = this.user.role_value;
    this.traders = this.$store.getters.traders;
  },
};
</script>

<style scoped>
</style>
